// ABOUTME: WhatsApp messaging utilities for TradesPurple
// ABOUTME: Handles phone number formatting and WhatsApp URL generation

/**
 * Clean phone number for WhatsApp URL
 * Removes common formatting characters and formats for international use
 */
export function cleanPhoneNumberForWhatsApp(phoneNumber: string): string {
  // Remove all formatting characters
  let cleaned = phoneNumber.replace(/[\s\-().]/g, '');

  // Handle UK numbers specifically (common case)
  // Remove leading (0) after +44 but be more specific
  if (cleaned.startsWith('+440')) {
    cleaned = '+44' + cleaned.substring(4);
  }

  // If no country code and starts with 0, assume UK
  if (cleaned.startsWith('0') && !cleaned.startsWith('+')) {
    cleaned = '+44' + cleaned.substring(1);
  }

  return cleaned;
}

/**
 * Generate WhatsApp URL with pre-filled message
 */
export function generateWhatsAppUrl(phoneNumber: string, message: string): string {
  const cleanedPhone = cleanPhoneNumberForWhatsApp(phoneNumber);
  const encodedMessage = encodeURIComponent(message);
  return `https://wa.me/${cleanedPhone}?text=${encodedMessage}`;
}
